export const stepPix=[
    {
        step: '1',
        text: "Copie o código Pix acima"
    },
    {
        step: '2',
        text: "Acesse o app do seu banco ou internet banking de preferência"
    },
    {
        step: '3',
        text: "Escolha pagar com Pix e cole o código"
    },
    {
        step: '4',
        text: "Antes de concluir o pagamento da sua fatura, confira se os dados bancários do beneficiário está como ”Claro Móvel” - CNPJ 40.432.544/0001-47. Se as informações estiverem iguais, finalize o pagamento"
    },
    {
        step: '5',
        text: "Após o pagamento ser finalizado, seu pagamento será aprovado em alguns instantes"
    }
]